import tw, { css } from "twin.macro";
import { getThemeStyle, type Mode } from "~/features/ui/get-theme-style";

type Props = {
  children: React.ReactNode;
  mode?: Mode;
};

const style = css`
  ${tw`max-w-screen-max mx-auto max:(border-l border-r)`}
`;

export function Wrap(props: Props) {
  const { children, mode, ...rest } = props;
  const themeStyles = getThemeStyle({ mode: mode as Mode });

  return (
    <div css={[style, themeStyles.border]} {...rest}>
      {children}
    </div>
  );
}
